<template>
  <div>
    <div v-if="status">
      {{ $t('not_found_category') }}
      <hr />
      <p v-html="text"></p>
    </div>
    <div v-else>
      <CategoriesList />
      <SortingBar :event="onPage" />
      <div class="col-md-12 category-page">
        <div class="overlay_page" @click="closeFilter"></div>
        <Filters :key="filtersKey" />
        <div class="col-md-9" style="min-height: 400px" v-if="loading">
          <Preloader />
        </div>
        <div class="col-md-9" v-else>
          <ProductsListTiles
            v-if="category.viewMode"
            :products="filteredProducts()"
          />
          <ProductsList
            v-else
            :products="filteredProducts()"
            :path="category.currentPath"
          />
          <CategoryPagination
            :total="total"
            :key="paginationKey"
            :event="onPage"
          />
          <hr />
          <p v-if="!$route.query.page" v-html="text"></p>
          <PricesBlock />
        </div>
      </div>
    </div>
    <!-- <script v-html="jsonld" type="application/ld+json"></script> -->
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import { mapActions, mapMutations, mapState } from 'vuex'
import Preloader from '@/components/Preloader'
import SortingBar from '@/components/category/SortingBar'
import Filters from '@/components/category/Filters'
import ProductsListTiles from '@/components/category/ProductsListTiles'
import ProductsList from '@/components/category/ProductsList'
import CategoryPagination from '@/components/category/CategoryPagination'
import PricesBlock from '@/components/category/PricesBlock'
import CategoriesList from '@/components/category/CategoriesList'

export default {
  name: 'Category',
  components: {
    Preloader,
    SortingBar,
    Filters,
    ProductsListTiles,
    ProductsList,
    CategoryPagination,
    PricesBlock,
    CategoriesList,
  },
  data() {
    return {
      productsKey: 'defaultKey',
      paginationKey: 'pgKey',
      filtersKey: 'fKey',
      total: 0,
      loading: true,
      status: false,
      fc: {},
      cc: {},
      title: '',
      description: '',
      text: '',
      isNoindex: false,
      seoCategory: null,
      defaultCurrency: 'UAH',
    }
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        {
          name: 'description',
          content: this.description,
        },
        this.isNoindex
          ? {
              name: 'robots',
              content: 'noindex, follow, noarchive',
            }
          : {},
      ],
    }
  },
  jsonld() {
    return {
      '@context': 'http://www.schema.org',
      '@type': 'product',
      name: this.title,
      image: this.categoryImage,
      description: this.description,
      offers: {
        '@type': 'AggregateOffer',
        lowPrice: Math.min(...this.categoryProductsPrices),
        highPrice: Math.max(...this.categoryProductsPrices),
        offerCount: this.category.products.length,
        priceCurrency: this.defaultCurrency,
      },
    }
  },
  computed: {
    categoryProductsPrices() {
      return this.category.products.map(
        ({ newPrice, price }) => newPrice || price
      )
    },
    categoryImage() {
      return (
        window.location.origin + `/img/categories/${this.category.slug}.png`
      )
    },
    ...mapState([
      'categories',
      'category',
      'headline',
      'filters',
      'selectedFilters',
      'SEOCategoriesMeta',
    ]),
    ...mapState({ filtersMobile: (state) => state.filtersMobile }),
  },
  methods: {
    onPage() {
      this.loading = true
      function composePath(...args) {
        let path = ''
        for (let arg of args) {
          path += arg
        }
        return path
      }

      let path = composePath(
        '/category/',
        this.category.currentPath,
        `?page=${this.category.page}`,
        `&limit=${this.category.perPage}`
      )
      this.fetchPagination(path).then(() => {
        this.loading = false
      })
      // console.log('*PATH', path)
    },
    filteredProducts() {
      let res = []
      res = [...this.category.products]
      this.total = this.category.total
      return res
    },
    getCategoryFilters() {
      let p = this.category.currentPath.split('/')
      let slug = p[0] === 'used' ? p[1] : p[0]
      return this.filters.find((f) => f.category === slug)
    },
    initCategory(path, cb) {
      // console.log('*InitCategory:', path, cb)
      this.loading = true
      this.status = false
      this.$store.dispatch('resetPagination')
      if (this.category.deferredFilters) {
        this.resetDeferredFilters()
      }
      // todo: filter out /page/n cases
      let breadcrumbs = []
      let categoryPath = '/product-category'
      // query api with numeric ids instead of slugs
      if (
        this.$h.parseFalsy(this.$h.env('VUE_APP_CATEGORIES_BY_ID', 'false'))
      ) {
        // console.log('*InitCategory: if:')
        let slugs = this.$h.parsePath(path)
        let ids = []
        let _c = this.categories
        //console.log('*HERE1', this.categories)
        slugs.forEach((s, i) => {
          if (!_c) return
          let c = _c.find((c) => c.slug === s)
          if (c) {
            ids.push(c.id)
            _c = c.children || null
            categoryPath += `/${s}`
            breadcrumbs.push({
              i,
              to: categoryPath,
              name: c[`name_${this.$i18n.locale}`],
            })
          }
        })
        if (ids.length) {
          let cpath = ids.shift()
          if (ids.length) cpath += `/${ids.join(',')}`
          this.fetchCategory(cpath)
            .then(() => {
              this.setHeadline(this.category[`name_${this.$i18n.locale}`])
              //console.log('*HERE2', this.category)
              slugs.forEach(() => {
                // todo: make breadcrum
                // console.log('*slug', slug)
              })
              cb && cb()
            })
            .catch((err) => {
              console.log('fetchCategory ids.length *[ERROR]', err)
              this.status = true
              cb && cb()
            })
        }
      } else {
        // console.log('*InitCategory: else:')
        // normal mode
        this.fetchCategory(path)
          .then(() => {
            // console.log('*InitCategory: else: >then')
            this.status = false
            let breadcrumbs = []
            let chain = this.$h.parsePath(path)
            let _c = this.categories
            //console.log('tyt')

            chain.forEach((p, i) => {
              if (!_c) return
              let c = _c.find((c) => c.slug === p)
              if (c) {
                _c = c.children || null
                categoryPath += `/${p}`
                breadcrumbs.push({
                  i,
                  to: categoryPath,
                  name: c[`name_${this.$i18n.locale}`],
                })
                this.cc = c
              }
            })
            //console.log('*HERE3', this.category)
            if (this.cc && this.category.currentPath.includes('used')) {
              //this.fc = cc
              this.setHeadline(
                this.cc[`name_${this.$i18n.locale}`]
                  ? this.cc[`name_${this.$i18n.locale}`] + ' б.у'
                  : ''
              )
              //console.log('*HERE', this.cc)
              //this.loadTitle()
            } else {
              //console.log('*Else')
              this.setHeadline(this.category[`name_${this.$i18n.locale}`])
            }
            this.setBreadcrumbs(breadcrumbs)
            this.loading = false
            cb && cb()
            // this.setHeadline('dfgdfgfd')
          })
          .catch((err) => {
            // console.log(this.categories, this.cc)
            // this.setHeadline(this.category[`name_${this.$i18n.locale}`])
            console.log('fetchCategory *[ERROR]', err)
            // //this.title = 'AppTown - tel (073) 143-00-11'
            this.status = true
            // cb && cb()
            let chain = this.$h.parsePath(path)
            let _c = this.categories
            //console.log('tyt')

            chain.forEach((p, i) => {
              if (!_c) return
              let c = _c.find((c) => c.slug === p)
              if (c) {
                _c = c.children || null
                categoryPath += `/${p}`
                breadcrumbs.push({
                  i,
                  to: categoryPath,
                  name: c[`name_${this.$i18n.locale}`],
                })
                this.cc = c
              }
            })
            if (this.cc && this.category.currentPath.includes('used')) {
              this.fc = this.cc
              this.setHeadline(
                this.cc[`name_${this.$i18n.locale}`]
                  ? this.cc[`name_${this.$i18n.locale}`] + ' б.у'
                  : ''
              )
              // console.log('*HERE', this.cc)
              //this.loadTitle()
            } else {
              //console.log('*Else')
              this.setHeadline(this.category[`name_${this.$i18n.locale}`])
            }
            this.setBreadcrumbs(breadcrumbs)
            cb && cb()
          })
      }
      // if(!this.fc.used_text_block_ru){
      //   this.fc.used_text_block_ru = ''
      // }
      // if(!this.fc.text_block_ru){
      //   this.fc.text_block_ru = ''
      // }
      //console.log('*END_INIT', this.fc)
    },
    updateProductsList() {
      this.productsKey = `k${Math.random()}`
      this.paginationKey = `pg${Math.random()}`
      this.filtersKey = `f${Math.random()}`
      this.loading = false
    },
    updateSEO() {
      const { params } = this.$router.currentRoute
      const { pathname } = window.location
      const pathQuery = this.getPathQueryWithFilters()
      const pathQueryList = Object.entries(pathQuery)
      let search = ''
      if (pathQueryList.length) {
        const list = pathQueryList.map((data) => data.join('='))
        search += `?${list.join('&')}`
      }
      let path = `${pathname}${search}`
      path = params.lang
        ? path.replace(new RegExp(`/${params.lang}`), '')
        : path
      this.seoCategory = (this.SEOCategoriesMeta || []).find(
        ({ url }) => url === path
      )
      const { locale } = this.$i18n
      // console.log('[***Category Meta***]', this.seoCategory)

      if (this.seoCategory) {
        this.isNoindex = false
        this.setHeadline(this.seoCategory[`h1_${locale}`])
        this.title = this.seoCategory[`title_${locale}`]
        this.description = this.seoCategory[`description_${locale}`]
      } else {
        this.isNoindex = Boolean(pathQueryList.length)
        this.loadTitle()
        this.loadDescription()
      }

      // if (this.isNoindex) {
      //   console.warn(
      //     '[***Category Noindex***]',
      //     'This category is closed for index'
      //   )
      // } else {
      //   console.info(
      //     '[***Category Index***]',
      //     'This category is opened for indexing'
      //   )
      // }

      const { page } = this.$route.query
      if (page) {
        this.title = this.$t('paginationTitle', {
          title: this.title,
          page,
        })
        this.description = this.$t('paginationDescription', {
          description: this.description,
          page,
        })
      }

      console.log('updated SEO!')
    },
    loadText() {
      // console.log('*FC-CC', this.fc, this.cc)
      if (this.category.currentPath.includes('used')) {
        if (this.cc) {
          this.text = this.cc[`used_text_block_${this.$i18n.locale}`]
        } else {
          this.text = ''
        }
      } else {
        if (this.fc) {
          this.text = this.fc[`text_block_${this.$i18n.locale}`]
        } else {
          this.text = ''
        }
      }
    },
    loadTitle() {
      this.title = this.$t('meta.category.titleTmpl', {
        h1: this.headline,
      })
      //console.log('*used', this.cc)
      // if (this.category.currentPath.includes('used')) {
      //   //console.log('1', this.fc)
      //   if (this.fc && this.cc.used_meta) {
      //     return (this.title = this.cc.used_meta[`title_${this.$i18n.locale}`])
      //   } else if (this.fc) {
      //     return (this.title =
      //       this.fc[`name_${this.$i18n.locale}`] + ' ' + this.$t('descTmpl'))
      //   }
      // } else {
      //   if (this.fc && this.fc.meta) {
      //     //console.log('2', this.fc, this.fc.meta)
      //     if (this.fc.meta[`title_${this.$i18n.locale}`]) {
      //       return (this.title = this.fc.meta[`title_${this.$i18n.locale}`])
      //     } else {
      //       return (this.title =
      //         this.fc[`name_${this.$i18n.locale}`] + ' ' + this.$t('descTmpl'))
      //     }
      //   } else if (this.fc) {
      //     return (this.title =
      //       this.fc[`name_${this.$i18n.locale}`] + ' ' + this.$t('descTmpl'))
      //   }
      // }
    },
    loadDescription() {
      this.description = this.$t('meta.category.descriptionTmpl', {
        h1: this.headline,
      })
      // if (this.category.currentPath.includes('used')) {
      //   if (this.fc && this.fc.used_meta) {
      //     this.description = this.fc.used_meta[
      //       `description_${this.$i18n.locale}`
      //     ]
      //   } else if (this.fc) {
      //     this.description =
      //       this.fc[`name_${this.$i18n.locale}`] + ' ' + this.$t('descTmpl')
      //   }
      // } else {
      //   if (this.fc && this.fc.meta) {
      //     this.description = this.fc.meta[`description_${this.$i18n.locale}`]
      //   } else if (this.fc) {
      //     this.description =
      //       this.fc[`name_${this.$i18n.locale}`] + ' ' + this.$t('descTmpl')
      //   }
      // }
    },
    et() {
      if (this.category && this.category.products) {
        let listcat = []
        let chain = this.$h.parsePath(this.$route.params.pathMatch)
        let _c = this.categories
        let cc

        chain.forEach((p) => {
          if (!_c) return
          let c = _c.find((c) => c.slug === p)
          if (c) {
            _c = c.children || null
            listcat.push({
              name: c[`name_${this.$i18n.locale}`],
            })
            cc = c
          }
        })

        //console.log(this.category['page'])
        const item_et = []
        const item_list_id = uuidv4()
        const item_list_name =
          cc && this.category.currentPath.includes('used')
            ? cc[`name_${this.$i18n.locale}`]
              ? `${cc[`name_${this.$i18n.locale}`]}  б.у`
              : ''
            : this.category[`name_${this.$i18n.locale}`]
        let variant = ''
        this.category.products.forEach((p, i) => {
          //console.log(p)
          //console.log(i)
          if (p['filters']) {
            if (p['filters'][0]['color']) {
              variant = p['filters'][0]['color']
            }
            if (variant && p['filters'][0]['memory']) {
              variant = variant + ' ' + p['filters'][0]['memory']
            }
          }
          //console.log(this.category)
          if (this.category['page'] > 1) {
            i =
              i +
              this.category['page'] * this.category['perPage'] -
              this.category['perPage']
          }
          i++
          //console.log(i)
          const listcat_full = listcat
            .map(function (elem) {
              return elem['name']
            })
            .join('/')
          item_et.push({
            list_name: p[`name_${this.$i18n.locale}`],
            item_id: p['id'],
            price: p['newPrice'] ? p['newPrice'] : p['price'],
            currency: this.defaultCurrency,
            item_brand: 'Apple',
            item_category: listcat_full,
            item_list_name,
            item_list_id,
            index: i,
            quantity: 1,
          })
        })
        //console.log(item_et)
        this.$gtag.event('view_item_list', {
          items: item_et,
        })
      }
    },
    closeFilter() {
      this.setFiltersMobile(!this.filtersMobile)
    },
    ...mapMutations([
      'resetDeferredFilters',
      'setBreadcrumbs',
      'setFiltersMobile',
      'setCategoryPage',
    ]),
    ...mapActions(['fetchCategory', 'setHeadline', 'fetchPagination']),
    getPathQueryWithFilters() {
      const categoryFilters = this.getCategoryFilters()
      const categoryFiltersKeys = (categoryFilters?.attributes || []).map(
        ({ slug }) => slug
      )
      const pathQuery = {}
      const { query } = this.$router.currentRoute
      const queryKeys = Object.keys(query)
      queryKeys.forEach((queryKey) => {
        if (categoryFiltersKeys.includes(queryKey)) {
          pathQuery[queryKey] = query[queryKey]
        }
      })

      return pathQuery
    },
    initFilters() {
      const pathQuery = this.getPathQueryWithFilters()
      if (Object.keys(pathQuery).length) {
        this.$store.commit('setSelectedFilters', pathQuery)
      }
    },
    initPagination() {
      const queryKey = this.$route.query.page

      if (queryKey == 1 || queryKey == 0) {
        this.$router.push({ path: this.$route.path, query: {} })
      } else if (queryKey) {
        this.setCategoryPage(queryKey)
        this.onPage()
      }
    },
    redirecting() {
      const {
        params: { lang, pathMatch },
      } = this.$route

      if (pathMatch === 'gadzhety-apple') {
        this.$router.push({ params: { lang, pathMatch: 'gadgets' } })
      }
    },
  },
  watch: {
    '$route.params.pathMatch': function (pathMatch) {
      this.redirecting()

      // console.log('*watch[pathMatch]', pathMatch)
      this.$store.commit('resetSelectedFilters')
      this.initCategory(pathMatch, () => {
        this.updateProductsList()
      })
    },
  },
  beforeMount() {
    this.redirecting()
    this.initFilters()

    if (Object.keys(this.$route.query).length === 0) {
      this.$store.commit('resetSelectedFilters')
    }

    this.initCategory(this.$route.params.pathMatch, () => {
      this.updateProductsList()
    })
    // console.log(this.category, this.categories, this.cc)
    if (!this.category.id) {
      const slug = this.category.currentPath.split('/')[1]
      this.fc = this.categories.filter((f) => f.slug === slug)[0]
      //console.log(this.fc)
      //console.log(this.category)
    } else {
      this.fc = this.category
      //console.log(this.fc)
      //console.log(this.category)
    }
  },
  mounted() {
    this.unsubscribeStore = this.$store.subscribe((mutation) => {
      if (mutation.type.match(/(un)?setSelectedFilter/)) {
        // console.log('*[filters changed]', mutation)
        //this.$store.state.category.currentPath
        this.initCategory(this.$route.params.pathMatch, () => {
          this.updateProductsList()
        })
      } else if (mutation.type === 'setCategorySort') {
        // console.log('*[sort changed]', mutation)
        this.initCategory(this.$route.params.pathMatch, () => {
          this.updateProductsList()
        })
      }
    })
    this.loadText()
    this.et()
    this.updateSEO()
    this.initPagination()
    const products = this.filteredProducts()
    this.$h.gtmDataLayerPush({
      ecomm_pagetype: 'category',
      ecomm_prodid: products.map(({ id }) => id),
      ecomm_totalvalue: products.reduce(
        (sum, { newPrice, price }) => sum + newPrice || price || 0,
        0
      ),
    })
  },
  updated() {
    if (!this.category.id) {
      const slug = this.category.currentPath.split('/')[1]
      this.fc = this.categories.filter((f) => f.slug === slug)[0]
    } else {
      this.fc = this.category
    }
    //console.log('*UPDATE', this.fc)
    this.loadText()
    this.et()
    this.updateSEO()
  },
  beforeDestroy() {
    this.unsubscribeStore()
  },
}
</script>

<style>
@media (min-width: 992px) and (max-width: 1024px) {
  .col-md-9 {
    width: auto;
  }
}
</style>
